import { HttpResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ApiService } from 'src/app/services/api.service';
import { Location } from '@angular/common';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { MatSelectChange } from '@angular/material/select';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import endpoints from 'src/app/helpers/endpoints';

@Component({
  selector: 'fury-add-edit-service-agreement',
  templateUrl: './add-edit-service-agreement.component.html',
  styleUrls: ['./add-edit-service-agreement.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class AddEditServiceAgreementComponent implements OnInit, OnDestroy {

  serviceAgreementForm!: FormGroup;
  serviceId: string = '';
  editorConfig = {
    allowedContent: false,
    toolbarGroups: [
      { name: 'clipboard', groups: ['clipboard', 'undo'] },
      { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
      { name: 'links' }, { name: 'insert' },
      { name: 'document', groups: ['mode', 'document', 'doctools'] },
      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
      { name: 'styles' },
      { name: 'colors' }
    ],
    forcePasteAsPlainText: false,
    image_previewText: ' '
  };
  planCoveredItems = [];
  ngUnsubscribe = new Subject<void>();
  constructor(
    private api: ApiService,
    private ar: ActivatedRoute,
    public location: Location
  ) { }

  ngOnInit(): void {
    this.formInIt();
    this.ar.params.pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => { if (res) { this.serviceId = res['id']; if (this.serviceId) this.getServiceAgreementDetails() } })
    this.serviceAgreementForm.controls['itemType'].valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
     if(res){
      this.getCoverItems(res);
     }
      
    })
  }
  formInIt() {
    this.serviceAgreementForm = new FormGroup({
      title: new FormControl('', [Validators.required]),
      content: new FormControl('', [Validators.required]),
      order: new FormControl('', [Validators.required, Validators.min(1)]),
      itemType: new FormControl(''),
      coveredItemDetail: new FormArray([])
    });
  }
  get coverItemDetails(){
    return this.serviceAgreementForm.get('coveredItemDetail') as FormArray;
  }
  getServiceAgreementDetails() {
    this.api.get(endpoints.settings.serviceAgreement.getServiceAgreementType(this.serviceId)).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (res: HttpResponse<any>) => {
        if (res.status === 200) {
          this.serviceAgreementForm.patchValue(res.body?.serviceAgreementType);
          let data : any[] = res.body?.serviceAgreementType?.coveredItemDetail;
          if(data){
            data.forEach(element => {
              let itemGroup = new FormGroup( {
                id : new FormControl(element?.id, [Validators.required]),
                title: new FormControl(element?.title, [Validators.required]),
                content: new FormControl(element?.content, [Validators.required])
              })     
              this.coverItemDetails.push(itemGroup);
            })
          }
        }
      }
    })
  }
  selectItemHandleChange(item: MatSelectChange){
   if(item.value){
    this.coverItemDetails.controls.forEach((element: FormGroup)=>{
      element.controls['id'].setValue(null);
      element.controls['title'].setValue(null);
    })
   }
    
  }
  getCoverItems(itemType: string){
    this.api.get(endpoints.settings.serviceAgreement.getCoveredItems(itemType)).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: HttpResponse<any>)=>{
      if(res.body){
        this.planCoveredItems = res.body?.planCoveredItems;
      }
    })
  }
   addCoveredItem(): void {
    const coveredItem = new FormGroup({
      id: new FormControl('', [Validators.required]),
      title: new FormControl('', [Validators.required]),
      content: new FormControl('', [Validators.required])
    });
    this.coverItemDetails.push(coveredItem);
  }

  deleteCoveredItem(index: number): void {
    this.coverItemDetails.removeAt(index);
  }
  selectCoverItemHandleChange(item: MatSelectChange, index: number){
   const findData =  this.planCoveredItems.find((ele:any)=> ele?.planCoverItemId === item.value);
   this.coverItemDetails.controls[index].get('title').setValue(findData?.title);
  }
  submit() {
    if (this.serviceAgreementForm.valid) {
      if(this.serviceAgreementForm.value?.itemType && !this.coverItemDetails.controls.length){
        this.api.alert('Please add cover item content by clicking Add Content button', ErrorType.Error);
        return;
      }
      let payload =  this.serviceAgreementForm.value;
      payload.coveredItemDetail = this.serviceAgreementForm.value.coveredItemDetail.map((item: any, index: number) => {
        return{...item, order: index + 1};
      })
      if(!this.serviceAgreementForm.value?.itemType){
        payload.coveredItemDetail = [];
      }
      if(!this.serviceId){
        this.api.post(endpoints.settings.serviceAgreement.createServiceAgreement, payload).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any)=>{
          if(res.body){
            this.api.alert(res.body.message, ErrorType.Success);
            this.location.back();
          }
        }, err =>{
          if(err){
          if(err.errors?.order){
            this.serviceAgreementForm.controls['order'].setErrors({notValid: true})
          }
            this.api.alert(err.message, ErrorType.Error);
          }
        })
      } else {
        this.api.patch(endpoints.settings.serviceAgreement.updateServiceAgreement(this.serviceId), payload).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any)=>{
          if(res.body){
            this.api.alert(res.body.message, ErrorType.Success);
            this.location.back();
          }
        }, err =>{
          if(err){
          if(err.errors?.order){
            this.serviceAgreementForm.controls['order'].setErrors({notValid: true})
          }
            this.api.alert(err.message, ErrorType.Error);
          }
        })
      }
      
    } else { 
      this.serviceAgreementForm.markAllAsTouched(); 
    }
  }
  moveCoveredItem(index: number, direction: number) {
    const coveredItems = this.coverItemDetails.controls;
    const currentValue = { ...coveredItems[index].value };
    const directionValue = { ...coveredItems[index + direction].value };
    coveredItems[index].patchValue(directionValue);
    coveredItems[index + direction].patchValue(currentValue);
    this.serviceAgreementForm.get('coveredItemDetail')?.updateValueAndValidity();
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
